<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
  -->

<template>
  <v-alert v-if="loadingError" type="error" :value="loadingError" class="mb-3">
    {{ loadingError }}
  </v-alert>
  <div v-else class="app-registration-container">
    <v-dialog
      v-model="loadingUserInvitation"
      transition="false"
      persistent
      fullscreen
      content-class="loading-dialog"
    >
      <v-container fill-height>
        <v-layout row justify-center align-center>
          <v-progress-circular
            indeterminate
            color="primary"
            :size="70"
            :width="7"
          />
        </v-layout>
      </v-container>
    </v-dialog>

    <ul v-if="stepper.show" class="app-visual-step-bar">
      <li :class="{ 'app-chevron-item-complete': stepper.currentStep >= 1 }">
        <span>Choose a Plan &amp; Options</span>
      </li>
      <li :class="{ 'app-chevron-item-complete': stepper.currentStep >= 2 }">
        <span>Account &amp; Payment Info</span>
      </li>
      <li :class="{ 'app-chevron-item-complete': stepper.currentStep >= 3 }">
        <span>Confirm</span>
      </li>
      <li :class="{ 'app-chevron-item-complete': stepper.currentStep >= 4 }">
        <span>Thank you!</span>
      </li>
    </ul>

    <registration-plan-options v-if="stepper.currentStep === 1" />
    <registration-account-info
      v-show="stepper.currentStep === 2 && !loadingUserInvitation"
    />
    <registration-confirmation v-show="stepper.currentStep === 3" />
    <registration-thank-you v-show="stepper.currentStep === 4" />
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex"
import RegistrationPlanOptions from "@/components/Registration-Plan-Options"
import RegistrationAccountInfo from "@/components/Registration-Account-Info"
import RegistrationConfirmation from "@/components/Registration-Confirmation"
import RegistrationThankYou from "@/components/Registration-Thank-You"
import analytics from "@/service/analytics"

export default {
  computed: mapGetters(["stepper"]),

  props: {
    plan: {
      type: String,
      required: true
    },
    invitationId: {
      type: String,
      required: false,
      default: null
    }
  },

  data() {
    return {
      loadingUserInvitation: false,
      loadingError: null
    }
  },

  components: {
    RegistrationPlanOptions,
    RegistrationAccountInfo,
    RegistrationConfirmation,
    RegistrationThankYou
  },

  created() {
    this.updatePlanTypeFromURL()
  },

  methods: {
    ...mapMutations([
      "updatePlanType",
      "updateCurrentStep",
      "updateSearchOptions"
    ]),

    ...mapActions(["loadInvitation"]),

    updatePlanTypeFromURL() {
      let signupType = ""

      if (this.plan.toLowerCase() === "company") {
        signupType = "Paid"
        this.updatePlanType("COMPANY")
      } else if (
        this.plan.toLowerCase() === "invitation" &&
        this.invitationId
      ) {
        signupType = "Invitation"

        this.updatePlanType("INVITATION")
        this.retrieveInvitation(this.invitationId)

        this.updateCurrentStep(2)
      } else {
        signupType = "Trial"

        this.updatePlanType("FREE")
        this.updateCurrentStep(2)

        this.updateSearchOptions(["NAME", "NPI"])
      }

      analytics.logAnalytic("Starts Sign-Up", {
        "Sign-Up Type": signupType
      })
    },

    retrieveInvitation(invitation) {
      this.loadingError = false
      this.loadingUserInvitation = true

      this.loadInvitation(invitation)
        .catch(
          () =>
            (this.loadingError =
              "Could not load user invitation at this time. Please try again later.")
        )
        .finally(() => (this.loadingUserInvitation = false))
    }
  }
}
</script>

<style lang="scss" scoped>
.app-registration-container {
  max-width: 71rem;
  margin: 0.5rem auto 2rem auto;
  text-align: center;
}

.app-visual-step-bar {
  max-width: 41.5rem;
  margin: 0 auto 3rem auto;
  @include app-chevron-bar;
}
</style>



// WEBPACK FOOTER //
// src/components/Registration.vue